import { isServer } from "@/src/lib/runtime";

export async function getRequestContext(): Promise<{
  tid?: string;
  path?: string;
  params: {
    cloudTasksTaskName?: string;
    taskId?: string;
    patientId?: string;
  };
}> {
  if (!isServer) {
    return { params: {} };
  }

  try {
    const { headers } = await import("next/headers");
    const headersList = await headers();
    const tid = headersList.get("x-trace-id");
    const path = headersList.get("x-path");
    const cloudTaskName = headersList.get("x-cloudtasks-taskname");
    const taskId = headersList.get("x-task-id");
    const patientId = headersList.get("x-patient-id");

    return {
      ...(tid && { tid }),
      ...(path && { path }),
      params: {
        ...(cloudTaskName && { cloudTaskName }),
        ...(taskId && { taskId }),
        ...(patientId && { patientId }),
      },
    };
  } catch {
    return { params: {} };
  }
}
